module.exports = __webpack_public_path__ + "img/back-bottom-right1.86485673.png";